import type { BlockPageBreak } from 'shared-types';

type LocaleData = BlockPageBreak['locales'][string];

const defaultBlockData = {};

const translatable: LocaleData['translatable'] = {};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockPageBreakData: BlockPageBreak = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockPageBreak['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
